<template>
<div class="header__navigation--wrap">
  <div id="header-menu" class="header__navigation">
    <div class="header__navigation--container">
      <div class="header__navigation--container--close" @click="closeMenu">
        <span></span>
        <span></span>
      </div>
      <div class="header__navigation--container--nav">
        <div class="header__navigation--container--nav--list">
          <div @click="closeMenu" class="header__navigation--container--nav--list--items" id="navlist--item-1">
            <router-link to="/" tag="a" ref="navlist--items">{{ $t("navigationTranslate.home") }}</router-link>
          </div>
          <div @click="closeMenu" class="header__navigation--container--nav--list--items" id="navlist--item-2">
            <router-link to="/about" tag="a" ref="navlist--items">{{ $t("navigationTranslate.about") }}</router-link>
          </div>
          <div @click="closeMenu" class="header__navigation--container--nav--list--items" id="navlist--item-3">
            <router-link to="/services" tag="a" ref="navlist--items">{{ $t("navigationTranslate.services") }}</router-link>
          </div>
          <div @click="closeMenu" class="header__navigation--container--nav--list--items" id="navlist--item-4">
            <router-link to="/team" tag="a" ref="navlist--items">{{ $t("navigationTranslate.team") }}</router-link>
          </div>
          <!-- <div @click="closeMenu" class="header__navigation--container--nav--list--items" id="navlist--item-5">
            <router-link to="/faq" tag="a" ref="navlist--items">{{ $t("navigationTranslate.faq") }}</router-link>
          </div> -->
          <div @click="closeMenu" class="header__navigation--container--nav--list--items" id="navlist--item-6">
            <router-link to="/resources" tag="a" ref="navlist--items">{{ $t("navigationTranslate.resources") }}</router-link>
          </div>
          <div @click="closeMenu" class="header__navigation--container--nav--list--items" id="navlist--item-7">
            <router-link to="/contact" tag="a" ref="navlist--items">{{ $t("navigationTranslate.contact") }}</router-link>
          </div>
        </div>
      </div>
      <!-- <div class="header__navigation--container--nav--contact">
        <a href="mailto:reception@lgiguere.com"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25"><text transform="translate(4.4 16.8)" font-size="16" fill="#fff" font-family="ArialMT, Arial">@</text></svg></a>
        <a href="+15142798977"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25"><title>phone</title><path d="M16.4,3.2H8.6A1.4,1.4,0,0,0,7.2,4.6V20.4a1.4,1.4,0,0,0,1.4,1.4h7.8a1.4,1.4,0,0,0,1.4-1.4V4.6A1.4,1.4,0,0,0,16.4,3.2ZM10.6,4h3.8c.1,0,.2.2.2.3s-.1.4-.2.4H10.6c-.1,0-.2-.2-.2-.4S10.5,4,10.6,4Zm1.9,16.5a.9.9,0,1,1,.9-.9A.9.9,0,0,1,12.5,20.5Zm4.3-3H8.2V5.5h8.6Z" fill="#fff"/></svg></a>
        <a href=""><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25"><path d="M10.7 8.5v1.8H9.4v2.2h1.3v6.6h2.8v-6.6h1.8s.2-1.1.3-2.2h-2.1V8.7a.6.6 0 0 1 .6-.5h1.5V5.9h-2c-2.9 0-2.9 2.2-2.9 2.6z" fill="#fff"/></svg></a>
        <a href=""><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25"><title>twitter</title><path d="M17.6,12a1.7,1.7,0,0,0,1.5-.9,2.1,2.1,0,0,1-1.6.2c0-.1-.1-.2-.1-.3a2.8,2.8,0,0,0-2.8-2.2h.3c.2,0,1-.2.8-.5s-1.1.2-1.2.3.6-.3.7-.6l-1.1.5a.5.5,0,0,0,.2-.4,6.3,6.3,0,0,0-2,3.2l-1-.8L7.9,8.9c-.1.6.2,1.2,1.1,1.7H8.2c.1.6.5,1.1,1.5,1.3a1.1,1.1,0,0,0-.9.4,1.5,1.5,0,0,0,1.6.8c-1,.4-.4,1.2.4,1.1a3.5,3.5,0,0,1-4.9.1c3.3,4.6,10.6,2.7,11.6-1.7a1.8,1.8,0,0,0,1.6-.6A3.7,3.7,0,0,1,17.6,12Z" fill="#fff"/></svg></a>
        <a href=""><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25"><title>linkedin</title><path d="M19.1,13.9v4.9H16.3V14.3c0-1.2-.4-2-1.5-2a1.6,1.6,0,0,0-1.4,1.1c-.1.1-.1.4-.1.7v4.7H10.5V10.3h2.8v1.2h0a2.7,2.7,0,0,1,2.5-1.4C17.7,10.1,19.1,11.3,19.1,13.9ZM7.5,6.2A1.4,1.4,0,0,0,5.9,7.7,1.4,1.4,0,0,0,7.5,9.1h0A1.4,1.4,0,0,0,9.1,7.7,1.4,1.4,0,0,0,7.5,6.2ZM6.1,18.8H8.9V10.3H6.1Z" fill="#fff"/></svg></a>
      </div> -->
    </div>
  </div>
</div>
</template>

<script>

export default {
  name: 'header-menu',
  props: {
    isActive: Boolean
  },
  data () {
    return {
      locale: 'en'
    }
  },
  watch: {
    locale (val) {
      this.$i18n.locale = val
    }
  },
  methods: {
    closeMenu() {
      this.isActive = false;
      this.$emit('reactiveIsActive', this.isActive);
    }
  }
}
</script>

<style lang="css">
</style>
